var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marketing-options" }, [
    _c("p", { staticClass: "title typographies-paragraph-x-large-semibold" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.$l10n.__("Options marketing")) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "option" },
      [
        _c("CompassSwitch", {
          attrs: { value: true, disabled: true, size: "medium" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "option__content" },
          [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Marketing")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "typographies-paragraph-medium-regular option__description"
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Collectez des leads et créez des superbes campagnes emailing, SMS et automation"
                      )
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "CompassSelect",
              {
                staticClass: "option-select-marketing-plan",
                attrs: { value: _vm.marketingLevelSelectedOption.id },
                on: {
                  "update:value": function(value) {
                    return _vm.updateLevelOption({
                      optionNameKey: "pack_marketing",
                      optionId: value
                    })
                  }
                }
              },
              _vm._l(_vm.options.pack_marketing, function(marketingLevel) {
                return _c("CompassDropdownSelectOption", {
                  key: marketingLevel.id,
                  attrs: {
                    disabled: _vm.checkMarketingLevelOptionDisabled(
                      marketingLevel.item_id
                    ),
                    label: marketingLevel.level,
                    value: marketingLevel.id
                  }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "typographies-paragraph-medium-semibold price" },
          [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.priceMarketingLevelSelected) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _vm.marketingLevelSelectedOption.amount > 0
              ? _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                /" +
                        _vm._s(
                          _vm.recurrencyLabel(
                            _vm.marketingLevelSelectedOption.unit_period
                          )
                        )
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "upsell-marketing-items" },
      [
        _c("ChargebeeUpsellMarketingItemEmailPack", {
          attrs: {
            data: _vm.packMarketingEmailFull,
            enabled: _vm.packMarketingEmailIsEnabled,
            label: _vm.$t.__(
              "pages.account.upsell.marketing.ChargebeeUpsellMarketing.pack_additional_emails"
            ),
            "number-chosen": _vm.packMarketingEmailFull.quantity,
            amount: _vm.packMarketingEmailFull.price,
            "tooltip-text": _vm.$t.__(
              "pages.account.upsell.marketing.ChargebeeUpsellMarketing.purchase_one_time_credits_from_your_settings"
            )
          },
          on: {
            onNumberChosenChange: function(numberChosen) {
              return _vm.updatePackEmailQuantity(numberChosen)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "ChargebeeUpsellMarketingItem",
          {
            attrs: {
              description: _vm.$t.__(
                "pages.account.upsell.marketing.ChargebeeUpsellMarketing.use_multiple_sending_domains"
              ),
              enabled:
                _vm.getMarketingOptionSelectedLevel ===
                _vm.marketingLevelEnum.BUSINESS,
              label: _vm.$t.__(
                "pages.account.upsell.marketing.ChargebeeUpsellMarketing.multi_domain_sending"
              ),
              amount: _vm.options.pack_marketing_multi_domains_auth.price,
              "tooltip-text": _vm.$t.__(
                "pages.account.upsell.marketing.ChargebeeUpsellMarketing.purchase_one_time_credits_from_your_settings"
              )
            }
          },
          [
            _c("CompassSwitch", {
              attrs: {
                value: _vm.isOptionEnabled(_vm.marketingOptionEnum.MULTIDOMAIN),
                disabled: _vm.packMarketingMultiDomainIsDisabled,
                size: "medium"
              },
              on: {
                input: function(value) {
                  return _vm.updateOption(
                    _vm.marketingOptionEnum.MULTIDOMAIN,
                    value
                  )
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "ChargebeeUpsellMarketingItem",
              {
                attrs: {
                  description: _vm.$t.__(
                    "pages.account.upsell.marketing.ChargebeeUpsellMarketing.to_optimize_your_deliverability_with_ease"
                  ),
                  label: _vm.$t.__(
                    "pages.account.upsell.marketing.ChargebeeUpsellMarketing.domain_authentification"
                  ),
                  amount: _vm.options.pack_marketing_custom_domain.price,
                  "tooltip-text": _vm.$t.__(
                    "pages.account.upsell.marketing.ChargebeeUpsellMarketing.to_configure_multiple_domains"
                  )
                }
              },
              [
                _c("CompassSwitch", {
                  attrs: {
                    value: _vm.isOptionEnabled(_vm.marketingOptionEnum.DOMAIN),
                    size: "medium",
                    disabled: _vm.getOptionWasEnabledPreviously({
                      optionNameKey: _vm.marketingOptionEnum.DOMAIN
                    })
                  },
                  on: {
                    input: function(value) {
                      return _vm.updateOption(
                        _vm.marketingOptionEnum.DOMAIN,
                        value
                      )
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("ChargebeeUpsellMarketingDomainsManager", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOptionEnabled(_vm.marketingOptionEnum.DOMAIN),
                  expression: "isOptionEnabled(marketingOptionEnum.DOMAIN)"
                }
              ],
              attrs: {
                recurrence: _vm.getRecurrence,
                unitPriceDomain: _vm.options.pack_marketing_custom_domain.price,
                isMultiDomainsEnabled: _vm.isOptionEnabled(
                  _vm.marketingOptionEnum.MULTIDOMAIN
                ),
                isEnabled: _vm.isOptionEnabled(_vm.marketingOptionEnum.DOMAIN)
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ChargebeeUpsellMarketingItem",
          {
            attrs: {
              description: _vm.$t.__(
                "pages.account.upsell.marketing.ChargebeeUpsellMarketing.ideal_option_for_improving_deliverability_over_time"
              ),
              enabled:
                _vm.getMarketingOptionSelectedLevel ===
                _vm.marketingLevelEnum.BUSINESS,
              label: _vm.$t.__(
                "pages.account.upsell.marketing.ChargebeeUpsellMarketing.dedicated_ip"
              ),
              amount: _vm.options.pack_marketing_dedicated_ip.price,
              "tooltip-text": _vm.$t.__(
                "pages.account.upsell.marketing.ChargebeeUpsellMarketing.can_choose_two_dedicated_ips_max"
              )
            }
          },
          [
            _c(
              "CompassSelect",
              {
                attrs: {
                  value: _vm.dedicatedIpOptionQuantity.toString(),
                  disabled:
                    _vm.getMarketingOptionSelectedLevel !==
                    _vm.marketingLevelEnum.BUSINESS
                },
                on: {
                  "update:value": function(value) {
                    return _vm.updateDedicatedIpQuantity(value)
                  }
                }
              },
              _vm._l(3, function(_, n) {
                return _c("CompassDropdownSelectOption", {
                  key: n,
                  attrs: { label: n.toString(), value: n.toString() }
                })
              }),
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }